// extracted by mini-css-extract-plugin
export var offlineNotificaton = "ff_KV";
export var offlineNotificaton__button = "ff_KY";
export var offlineNotificaton__header = "ff_KX";
export var offlineNotificaton__text = "ff_KZ";
export var offlineNotificaton__withCookie = "ff_KW";